import { Typography } from '@mui/material'
import TextLabel from '../TextLabel/TextLabel'
import React from 'react'
import * as S from './UserGuidance.styles'

interface UserGuidanceProps {
    text?: string
    children: React.ReactNode
}

const UserGuidance: React.FC<UserGuidanceProps> = ({ text, children }) => (
  <S.Container>
    { text && <Typography>{text}</Typography> }
    <TextLabel width='100%' height='3.2rem'>
      {children}
    </TextLabel>
  </S.Container>
)

export default UserGuidance
